<img src="/assets/svg/logo-white.svg" class="logo" />
<h2>{{ 'internet_explorer_header' | translate }}</h2>
<p>
  {{
    whiteLabel.logoUrl
      ? ('internet_explorer_message_wl' | translate)
      : ('internet_explorer_message' | translate)
  }}
</p>
